import React from 'react';

import { useSpaceOutlet } from '../../app/space-outlet';
import { ContactPage } from '../contacts/contact.page';
import { SpaceLockedPlaceholder } from '../../features/billing/components/space-locked.placeholder';

export const SpaceContactsRoute: React.FC = () => {
  const { space, isSpaceLocked } = useSpaceOutlet();

  return isSpaceLocked ? <SpaceLockedPlaceholder /> : <ContactPage space={space} />;
};
